import { ErrorIcon } from 'assets/svgs';
import { CheckIcon } from 'components/icons';
import React from 'react';
import styles from './radio.module.scss';

const Radio = React.forwardRef(({ children, ...props }, ref) => (
  <label className={styles.label}>
    <input
      type="radio"
      {...props}
      name={props.name}
      className={styles.input}
      ref={ref}
      value={props.value}
      checked={props.isSelected}
      onChange={props.changed}
      data-testid={props.testId}
    />
    <span className={styles.span}>
      <CheckIcon />
      <div className={styles.text}>{children}</div>
    </span>

    {props.error && (
      <p className={styles.authFormGroupError} data-testid="radio-error">
        <ErrorIcon />
        {props.error}
      </p>
    )}
  </label>
));

export default Radio;
